import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./PostViewTrackingPrice.module.css";
import { usePostDetails } from "@/common/Contexts/PostDetailsContext";
import { useSearchParams } from "react-router-dom";
var PostViewTrackingPrice = function PostViewTrackingPrice() {
  var _postDetails$price, _postDetails$price$va;
  var _usePostDetails = usePostDetails(),
    postDetails = _usePostDetails.postDetails;
  var _ref = postDetails || {},
    footer = _ref.footer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  return /*#__PURE__*/React.createElement("div", {
    className: stl.trackingPrice
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("cash_price", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      color: (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? "" : "#00B64E"
    }
  }, footer !== null && footer !== void 0 && footer.total_price ? footer === null || footer === void 0 ? void 0 : footer.total_price : postDetails === null || postDetails === void 0 ? void 0 : (_postDetails$price = postDetails.price) === null || _postDetails$price === void 0 ? void 0 : (_postDetails$price$va = _postDetails$price.vat_price) === null || _postDetails$price$va === void 0 ? void 0 : _postDetails$price$va.text, /*#__PURE__*/React.createElement("span", null, t("sar", {
    ns: "web_common"
  })))), searchParams.get("isCancelled") === "true" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.isCancelled
  }, " ", t("request_canceled", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.fullypaid
  }, " ", t("fully_paid", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("remaining_amount", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, footer === null || footer === void 0 ? void 0 : footer.remaining_price, /*#__PURE__*/React.createElement("span", null, t("sar", {
    ns: "web_common"
  })))));
};
export default PostViewTrackingPrice;